module.exports = __webpack_public_path__ + "img/scene_relax_tw_big@2x.5c1a1940.png";